import SimpleHeader from '@/components/simple-header'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { sidebarMenus } from '@/routes/(inventory)/-module-components/sidebar/sidebar-menus'
import { ArrowUpDownIcon, SearchIcon, WorkflowIcon } from 'lucide-react'
import AutomationCard from './automation-card'
import AutomationListRow from './automation-list-row'

const Screen = () => {
    return (
        <>
            <SimpleHeader text='Automations' />
            <div className='flex items-center gap-2 p-4'>
                <div className='flex-1 flex items-center gap-2'>
                    <div className='flex items-center gap-1 border rounded-md px-2 shadow-sm'>
                        <SearchIcon className='w-4 h-4 text-gray-600' />
                        <Input placeholder='Search' className='w-[200px] h-8 border-none' />
                    </div>
                    <Button 
                        variant='outline'
                        size='sm'
                        className='shadow-sm'
                    >
                        <ArrowUpDownIcon className='w-4 h-4 mr-2' />
                        Sort
                    </Button>
                </div>
                <Button
                    className='shadow-sm bg-blue-700 text-white'
                >
                    <WorkflowIcon className='w-4 h-4 mr-2' />
                    Create Automation Workflow
                </Button>
            </div>

            <div className="flex items-center gap-1 text-xs text-muted-foreground font-medium mt-4 pl-2">
                <sidebarMenus.navViews.icon
                  className="w-3 h-3"
                  aria-hidden="true"
                />
                <span>Recent</span>
            </div>

            <div className="my-4 grid grid-cols-4 gap-4">
              <AutomationCard 
                title="Inventory" 
                description="Inventory Automations" 
                status="Ready"
                linkUrl="/branch/automations/inventory"
              />
            </div>

            {/* <div className="flex items-center gap-1 text-xs text-muted-foreground font-medium mt-4 pl-2">
                <sidebarMenus.navViews.icon
                  className="w-3 h-3"
                  aria-hidden="true"
                />
                <span>All</span>
            </div> */}

            {/* List-like component for all rows */}
            {/* <div className="mt-2 bg-white rounded-xl shadow-sm divide-y divide-gray-100">
              {[1,2,3,4,5,6,7,8,9,10].map((_, i) => (
                <AutomationListRow
                  key={i}
                  title="Inventory"
                  description="lorem ipsum"
                  status="Draft"
                  runs={0}
                />
              ))}
            </div> */}
        </>
    )
}

export default Screen